<script setup lang="ts">
const home = useHomeStore();
</script>

<template>
  <section>
    <router-link
      v-if="home.status === LoadStatus.Ready"
      to="/search/results?list=custom_d14d7854-e940-4b09-91bc-88fe46c15285"
      class="homepage-link ga-seasonal-link"
      data-menu-item="Spring Harvest All Age Songbook"
    >
      <Image
        src="https://cdn.ccli.com/songselect/web/images/sh-banner-2025-3840x356.jpg"
        alt="Spring Harvest All Age Songbook"
        class="h-full w-full"
      />
    </router-link>
    <div
      v-else
      class="homepage-link"
    >
      <span class="placeholder h-full w-full" />
    </div>
  </section>
  <!-- -->
</template>

<style scoped lang="postcss">
.homepage-link {
  @apply relative block h-16 overflow-hidden rounded-lg shadow-xl transition-all hover:brightness-90 md:h-32;
}
</style>
